export enum LOCALE {
  EN = 'en',
  ID = 'id',
}

export enum LOCALEMOBILE {
  English = 'en',
  Indonesian = 'id',
}
